import { createSlice } from "@reduxjs/toolkit";

interface successState {
  success: boolean;
  title: string;
  message: string;
  isPublished?: boolean;
  isDeleted?: boolean;
  isStudentCreated?: boolean;
  showViewScreenAction?: boolean;
  onClose?: () => void;
}

const initialState: successState = {
  success: false,
  title: "",
  message: "",
};

const successSlice = createSlice({
  name: "success",
  initialState,
  reducers: {
    setSuccessStatus: (
      state,
      action: {
        type: string;
        payload: {
          title: string;
          message: string;
          onClose?: () => void;
          isPublished?: boolean;
          isDeleted?: boolean;
          isStudentCreated?: boolean;
          showViewScreenAction?: boolean;
        };
      }
    ) => {
      state.success = true;
      state.title = action.payload.title;
      state.message = action.payload.message;
      state.isPublished = action.payload.isPublished;
      state.isDeleted = action.payload.isDeleted;
      state.isStudentCreated = action.payload.isStudentCreated;
      state.showViewScreenAction = action.payload.showViewScreenAction;
      state.onClose = action.payload.onClose;
    },
    resetSuccessStatus: (state) => {
      state.success = false;
      state.message = "";
      state.title = "";
      state.isPublished = undefined;
      state.isDeleted = undefined;
      state.isStudentCreated = undefined;
      state.showViewScreenAction = undefined;
      state.onClose = undefined;
    },
  },
});

export const { setSuccessStatus, resetSuccessStatus } = successSlice.actions;
export default successSlice.reducer;
